import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class TypeSelect extends React.Component {


    handleChange = (event) => {
        const { onChange, types } = this.props;

        onChange(event, types.find(x => x.id === event.target.value));
    };

    render() {
        const { value, types, all, error, isRequired, size } = this.props;

        if (types.length === 0) {
            return null;
        }

        return (
            <TextField
                select
                required={isRequired}
                error={error !== undefined}
                name="typeId"
                label="Type"
                value={value}
                onChange={this.handleChange}
                helperText={error ? error.errorMsg : ''}
                fullWidth
                size={size}
            >
                {all === true ? <MenuItem key={0} value={0}><em>Tous</em></MenuItem> : null}
                {types.map(type => (
                    <MenuItem key={type.id} value={type.id}>
                        {type.libelle}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}

TypeSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    types: PropTypes.array.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    size: PropTypes.string
};

export default TypeSelect;